import { render, staticRenderFns } from "./customerClear.vue?vue&type=template&id=1dc40f58&scoped=true&"
import script from "./customerClear.vue?vue&type=script&lang=js&"
export * from "./customerClear.vue?vue&type=script&lang=js&"
import style0 from "./customerClear.vue?vue&type=style&index=0&id=1dc40f58&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc40f58",
  null
  
)

export default component.exports